export enum GraphQLPageStatus {
	CURRENT = 'CURRENT',
	DRAFT = 'DRAFT',
}

export const PAGE_TREE_STATUSES = [GraphQLPageStatus.CURRENT, GraphQLPageStatus.DRAFT];

export const PAGE_TREE_STATUS_STRINGS = ['current', 'draft'];
